<template>
  <div class="logs-movimentacoes">
    <PainelHeader />

    <main class="logs-movimentacoes__content">
      <button type="button" class="logs-movimentacoes__back" @click="goBack">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
          <path d="M10 3L5 8l5 5V3z"/>
        </svg>
        Voltar
      </button>

      <section class="logs-movimentacoes__panel">
        <PainelSearchFilter
          name="logs"
          :search.sync="search"
          :selected-cliente-id.sync="selectedClienteId"
          :is-admin="isAdmin"
          :clientes="clientes"
          :refreshing="refreshing"
          @cliente-change="loadSalas"
          @refresh="refreshSalas"
        />

        <div v-if="loading" class="logs-movimentacoes__state">Carregando salas...</div>
        <div v-else-if="loadFailed" class="logs-movimentacoes__state logs-movimentacoes__state--error">
          <p>Não foi possível carregar as salas.</p>
          <button type="button" @click="loadSalas">Tentar novamente</button>
        </div>

        <PainelSalasTable
          v-else
          action-type="log"
          :rows="filteredRows"
          :columns="tableColumns"
          @action="abrirLogs"
        />
      </section>
    </main>

    <ModalLogsSala
      :aberto="modalLogsAberto"
      :sala-id="modalSala.id"
      :nome-sala="modalSala.protocolo"
      @fechar="fecharModalLogs"
    />
  </div>
</template>

<script>
import PainelHeader from '../components/PainelHeader.vue';
import PainelSearchFilter from '../components/PainelSearchFilter.vue';
import PainelSalasTable from '../components/PainelSalasTable.vue';
import ModalLogsSala from '../components/ModalLogsSala.vue';
import { listarClientes } from '../service/clientes.service';
import { carregarSalasPainel } from '../service/salas-list.service';
import { getClienteId, isAdminCliente, logout } from '../service/auth.service';
import { mapSalaRow, filterSalasBySearch, withClienteColumn } from '../utils/salas.utils';
import { showErrorToast } from '../service/toast.service';

const TABLE_COLUMNS = [
  { key: 'protocolo', label: 'Protocolo' },
  { key: 'status', label: 'Status atual' },
  { key: 'primario', label: 'Primário' },
  { key: 'nomePrimario', label: 'Nome primário' },
  { key: 'secundario', label: 'Secundário' },
  { key: 'nomeSecundario', label: 'Nome secundário' },
  { key: 'duracaoEspera', label: 'Duração da espera' },
  { key: 'duracaoChamada', label: 'Duração da chamada' },
  { key: 'atualizadoEm', label: 'Atualizado em' },
  { key: 'criadoEm', label: 'Criado em' }
];

export default {
  name: 'LogsMovimentacoes',

  components: {
    PainelHeader,
    PainelSearchFilter,
    PainelSalasTable,
    ModalLogsSala
  },

  data() {
    return {
      rows: [],
      clientes: [],
      search: '',
      selectedClienteId: '',
      isAdmin: isAdminCliente(),
      loading: false,
      refreshing: false,
      loadFailed: false,
      modalLogsAberto: false,
      modalSala: {
        id: null,
        protocolo: ''
      }
    };
  },

  computed: {
    tableColumns() {
      return withClienteColumn(TABLE_COLUMNS, this.isAdmin);
    },

    filteredRows() {
      return filterSalasBySearch(this.rows, this.search);
    }
  },

  mounted() {
    if (this.isAdmin) {
      this.loadClientes();
    }

    this.loadSalas();
  },

  methods: {
    goBack() {
      this.$router.push('/painel/dashboard');
    },

    async loadClientes() {
      try {
        this.clientes = await listarClientes();
      } catch (err) {
        showErrorToast('Não foi possível carregar a lista de clientes.');
      }
    },

    async loadSalas() {
      this.loading = true;
      this.loadFailed = false;

      const clienteId = getClienteId();
      if (!clienteId) {
        logout();
        this.$router.push('/painel');
        return;
      }

      try {
        const salas = await carregarSalasPainel({
          isAdmin: this.isAdmin,
          selectedClienteId: this.selectedClienteId,
          clienteId
        });

        this.rows = (salas || []).map(mapSalaRow);
      } catch (err) {
        showErrorToast('Não foi possível carregar as salas. Tente novamente em instantes.');
        this.loadFailed = true;
        this.rows = [];
      } finally {
        this.loading = false;
      }
    },

    async refreshSalas() {
      if (this.loading || this.refreshing) {
        return;
      }

      const clienteId = getClienteId();
      if (!clienteId) {
        logout();
        this.$router.push('/painel');
        return;
      }

      this.refreshing = true;

      try {
        const salas = await carregarSalasPainel({
          isAdmin: this.isAdmin,
          selectedClienteId: this.selectedClienteId,
          clienteId
        });

        this.rows = (salas || []).map(mapSalaRow);
        this.loadFailed = false;
      } catch (err) {
        showErrorToast('Não foi possível atualizar as salas. Tente novamente em instantes.');
      } finally {
        this.refreshing = false;
      }
    },

    abrirLogs(row) {
      this.modalSala = {
        id: row.id,
        protocolo: row.protocolo
      };
      this.modalLogsAberto = true;
    },

    fecharModalLogs() {
      this.modalLogsAberto = false;
      this.modalSala = { id: null, protocolo: '' };
    }
  }
};
</script>

<style scoped src="./LogsMovimentacoes.css"></style>
